import React, { Component } from 'react'
import { connect } from 'react-redux'
import SettingForm from './setting_form'
// import SettingsListFilter from './settingsListFilter'
import * as actions from '../../actions'
// import { reduxForm, Field } from 'redux-form'
// import { renderTextField, renderCheckbox, renderSelectField } from '../auth/form_helpers'
// import MenuItem from 'material-ui/MenuItem';
// import Paper from 'material-ui/Paper';
import {List, ListItem} from 'material-ui/List';
import ActionPayment from 'material-ui/svg-icons/action/payment';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';

var jsonpatch = require('fast-json-patch')
const uuidv4 = require('uuid/v4');
var params = '?';
var hasEdited = false;
var patchresponsed = true;

var shouldSave = true;
var closeRequest = null

const styles = {
  m15: {
    margin: 15,
  },
  customContentStyle: {
    width: '100%',
    maxWidth: 'none',
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  plusButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1,
  }
};
class Settings extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
    closeRequest = null
  }

  componentWillMount() {
    this.props.fetchMessage('/settings/yearly-fee', '?offset=0&limit=50');
  }

  componentDidMount() {
    var that = this
    closeRequest = function() {
      window.onbeforeunload = function() {
        that.setState({iscloserequest: true});
        that.handleFakeSubmit(false)
        if (that.state.openedform) {
          if (!that.state.isemptyonclose) {
            that.setState({iscloserequest: false});
            return 'You have unsaved changes!';
          }

        }
      }
    }
    closeRequest()
  }

  state = {
    open: false,
    openedform: false,
    iscloserequest: false,
    isemptyonclose: false,
  }

  handleOpen = ( val ) => {
    this.props.openSetting('/settings/yearly-fee', '/'+val);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleNewOpen = ( val ) => {
    this.props.openSetting('/settings/yearly-fee', '/'+val);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleClose = () => {
    this.handleFakeSubmit(false);
    //if (hasEdited) {
    //  if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.')) {
    //    this.props.closeSetting()
    //    this.props.fetchMessage('/settings/yearly-fee', params);
    //    this.setState({open: false});
    //  }
    //} else {
    //  this.props.closeSetting()
    //  this.props.fetchMessage('/settings/yearly-fee', params);
    //  this.setState({open: false});
    //}
  }

  handleSubmit({id, year, supporter, normal}) {
    let patchArrayCounter = 0;
    patchresponsed = true
    let patchArray = []
    // console.log({id, year, supporter, normal})
    // let loadedSetting = this.props.thissetting;
    let feeyear, suppporterfee, normalfee;
    if (typeof year !== 'undefined' && typeof year !== 'number') {
      feeyear =  parseInt(year, 10/*.replace(/[' ']/g, '')*/)
    } else {
      feeyear = year
    }
    if (typeof supporter !== 'undefined' && typeof supporter !== 'number') {
      suppporterfee = parseFloat(supporter.replace(/[' ']/g, ''))
    } else {
      suppporterfee = supporter
    }
    if (typeof normal !== 'undefined' && typeof normal !== 'number') {
      normalfee = parseFloat(normal.replace(/[' ']/g, ''))
    } else {
      normalfee = normal
    }

    let loadedSetting = {
      "id" : this.props.thissetting.id,
      "year" : this.props.thissetting.year,
      "supporter" : typeof this.props.thissetting.supporter === 'string' ? parseInt(String(this.props.thissetting.supporter).replace(/[' ']/g,''), 10) : this.props.thissetting.supporter,
      "normal" : typeof this.props.thissetting.normal === 'string' ? parseInt(String(this.props.thissetting.normal).replace(/[' ']/g,''), 10) : this.props.thissetting.normal
    }

    let edited = {
      "id" : id,
      "year" : feeyear,
      "supporter" : suppporterfee,
      "normal" : normalfee
    }
    var patch = jsonpatch.compare(loadedSetting, edited)

    patchArray.push({
      endpoint: '/settings/yearly-fee',
      params: '/'+id,
      patchvar: patch,
      needalert: false
    })
    let propsforpatch = this.props;
    let that = this;
    let cntrObj = {}
    cntrObj.lngt = patchArray.length;
    function patcher(maybeSave) {
      if (typeof maybeSave !== 'undefined' && maybeSave === true) {

        if (patchresponsed === true) {
          console.log('? patchArray.length === patchArrayCounter '+patchArray.length+'-'+patchArrayCounter)
          if (patchArray.length === patchArrayCounter) {
            // All PATCH done
            propsforpatch.fetchMessage('/settings/yearly-fee', params); // refresh list
            hasEdited = false;
            propsforpatch.openSetting('/settings/yearly-fee', '/'+id); // refresh single
            alert('Sikeres módosítás')
            patcher = null
          } else {
            document.getElementsByTagName("body")[0].addEventListener('patchresponse'+patchArrayCounter, function (e) {
              // we have response
              patchresponsed = true
              patchArrayCounter++
              if (patcher !== null) {
                patcher(shouldSave);
              }
            }, false)
            if (typeof patchArray[patchArrayCounter] !== 'undefined' && typeof patchArray[patchArrayCounter].del !== 'undefined' && patchArray[patchArrayCounter].del === true) {
              propsforpatch.deleteParticipant(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArrayCounter)
            } else {
              propsforpatch.patchItem(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArray[patchArrayCounter].patchvar, patchArray[patchArrayCounter].needalert, patchArrayCounter)
            }
            patchresponsed = false
          }
        }

      } else {
        if (that.state.iscloserequest) { // EZ LETT BERAKVA
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            that.setState({isemptyonclose : true})
            return true
          } else {
            that.setState({isemptyonclose : false})
            return false
          }
        } else {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            propsforpatch.closeSetting()
            propsforpatch.fetchMessage('/settings/yearly-fee', params);
            that.setState({open: false});
            that.setState({openedform: false});
          } else {
            if (window.confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            propsforpatch.closeSetting()
            propsforpatch.fetchMessage('/settings/yearly-fee', params);
            that.setState({open: false});
            that.setState({openedform: false});
            }
          }
        }
      }
    }

    patcher(shouldSave);

    /*
      if (shouldSave === true) {
        this.props.patchItem('/settings/yearly-fee', '/'+id, patch)
        this.props.fetchMessage('/settings/yearly-fee', params);

        this.props.openSetting('/settings/yearly-fee', '/'+id);
      } else {
        if (patch.length > 0) {
          if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            this.props.closeSetting()
            this.props.fetchMessage('/settings/yearly-fee', params);
            this.setState({open: false});
          }
        } else {
          this.props.closeSetting()
          this.props.fetchMessage('/settings/yearly-fee', params);
          this.setState({open: false});
        }
      }
    */

  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleFilter({query, category, diplomas, psychotherapist, newsletter}) {
    params = '?';
    if (typeof query !== 'undefined') {
      params = params + '&q='+query
    }
    if (typeof category !== 'undefined') {
      params = params + '&category='+category
    }
    if (typeof diplomas !== 'undefined') {
      params = params + '&diplomas='+diplomas
    }
    if (typeof psychotherapist !== 'undefined') {
      params = params + '&psychotherapist='+psychotherapist
    }
    if (typeof newsletter !== 'undefined') {
      params = params + '&newsletter='+newsletter
    }
    window.scrollTo(document.body, 0, 1250);
    this.props.fetchMessage('/settings/yearly-fee', params);
  }

  handleFakeSubmit = (should) => {
    if (should === false) {
      shouldSave = false;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    } else {
      shouldSave = true;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    }
  }

  render() {
    if(typeof this.props.message !== 'undefined' ) {
      let uu = uuidv4();
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="Beállítások"
          />
          <Dialog
            // title="Személy szerkesztése"
            actions={[
              <RaisedButton label='Mentés' onTouchTap={ this.handleFakeSubmit } primary={true} />,
              <FlatButton label='Bezár' onTouchTap={ this.handleClose } />
            ]}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
            contentStyle={styles.customContentStyle}
          >
            <SettingForm
              handleClose={this.handleClose.bind(this)}
              onSubmit={this.handleSubmit.bind(this)}
              errorMessage={this.props.errorMessage}
              settinginfos={this.props.thissetting}
              editinfos={this.props.editedsetting}
            />
          </Dialog>
          {/*
          <SettingsListFilter personcategories={this.props.personcategories} onSubmit={this.handleFilter.bind(this)} errorMessage={this.props.errorMessage} />
          */}
          <List>
          {
            this.props.message.map((option, index) => {
              return <ListItem
                onClick={this.handleOpen.bind(this, option.id)}
                key={index}
                leftIcon={<ActionPayment />}
                primaryText={
                  <span>
                    <span style={{color: darkBlack}}>{option.year}</span>
                    <small style={{color: lightBlack}}>
                      <span> - </span>
                      <span>
                        <span style={{color: darkBlack}}>Támogató:</span>
                        <span> {option.supporter} </span>
                      </span>
                      <span>
                        <span style={{color: darkBlack}}>Normál:</span>
                        <span> {option.normal} </span>
                      </span>
                    </small>
                  </span>
                }
                />
            })

          }
          </List>
          <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
              if (this.props.message.length > 49) {
                this.props.fetchMoreMessage('/settings/yearly-fee', params+'&offset='+this.props.message.length+'&limit=50');
              }
            }}
          />
          <FloatingActionButton className="plusSetting" style={styles.plusButton} onClick={this.handleNewOpen.bind(this, uu)} key={uu}>
            <ContentAdd />
          </FloatingActionButton>

        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.auth.message,
    thissetting: state.settings.thissetting,
    editedsetting: state.settings.editedsetting,
    errorMessage: state.auth.error
  }
}

export default connect(mapStateToProps, actions)(Settings)


// WEBPACK FOOTER //
// ./src/components/settings/settings.js